import React from "react";
import { CustomLink } from "../link/link.comp";
import { StyledHero } from "./hero.styles";
import dynamic from "next/dynamic";
import { SocialProof } from "../socialProof/socialProof.comp";

const BracketsHeroImage = dynamic(
  () => import("../bracketsHeroImage/bracketsHeroImage.comp"),
  {
    ssr: false,
  }
);

export const Hero = () => {
  return (
    <StyledHero>
      <div className="hero-content-container">
        <div className="details">
          {/* <a
            href="https://www.producthunt.com/products/brackets-by-common-ninja?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-brackets-by-common-ninja"
            target="_blank"
            style={{ margin: '-20px 10px 0', padding: 0 }}
          >
            <img
              src="https://api.producthunt.com/widgets/embed-image/v1/product_review.svg?product_id=1165283&theme=light"
              alt="Brackets by Common Ninja - Drive engagement with interactive brackets | Product Hunt"
              style={{ width: "250px", height: "54px" }}
              width="250"
              height="54"
              loading="lazy"
            />
          </a> */}
          <h1>Free Online Bracket Maker</h1>
          <h2>
            Create advanced online brackets & tournaments with images, voting,
            predictions, and real-time updates.
          </h2>
          <CustomLink
            href="https://www.commoninja.com/brackets/editor?via=brackets"
            title="Create a Bracket for Free"
          >
            Create a Bracket for Free
          </CustomLink>
          <SocialProof />
        </div>
      </div>
      <BracketsHeroImage />
    </StyledHero>
  );
};
